<template>
  <div>
    <div
      v-for="(header, index) in currentTab.headers"
      :key="index"
      class="mb-4"
    >
      <label
        v-if="header.field.type !== null"
        for=""
        class="block text-gray-700 text-sm font-bold mb-2"
        >{{ header.title }}</label
      >
      <input
        v-if="header.field.type === 'text'"
        type="text"
        class="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-blue-500"
        v-model="form.data[header.field.name]"
      />
      <input
        v-if="header.field.type === 'number'"
        class="appearance-none block w-full text-gray-700 border-2 focus:border-blue-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
        :id="header.field.name"
        type="number"
        :min="header.field.min || 1"
        :max="header.field.max || 100"
        v-model="form.data[header.field.name]"
      />
      <Treeselect
        v-else-if="header.field.type === 'select'"
        :multiple="header.field.multiple"
        :options="
          getOptions(
            currentTab.extras[header.field.options],
            header.field.optionName
          )
        "
        v-model="form.data[header.field.name]"
      />
    </div>
    <div class="flex items-center justify-end pt-4 border-t">
      <button
        class="py-2 px-4 border border-gray-600 hover:bg-indigo-600 hover:text-white hover:border-transparent rounded focus:outline-none"
        @click="addEntry(form)"
      >
        Crear
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  components: {
    Treeselect,
  },
  data() {
    return {
      form: {},
    };
  },
  computed: {
    ...mapState(["user"]),
    ...mapGetters(["currentTab"]),
  },
  methods: {
    ...mapActions(["addEntry"]),
    getOptions(extras, name) {
      return extras.map((extra) => {
        return { id: extra[name], label: extra[name] };
      });
    },
  },
  created() {
    this.form.action = this.currentTab.actions.post;
    this.form.data = Object.fromEntries(
      this.currentTab.headers.map((header) => [header.field.name, null])
    );
    this.form.data.user = this.user.num;
    this.form.data.colegio = this.user.colegio;
  },
};
</script>
